import React from 'react';
import { withTheme } from '../ThemeProvider';
import { StyledDrawerTitle } from './styles';

export interface DrawerTitleProps {
  title: string;
  icon?: React.ReactNode;
  className?: string;
  theme?: any;
}

const TitleComponent: React.FC<DrawerTitleProps> = ({
  title,
  icon,
  className,
}: DrawerTitleProps) => {
  return (
    <StyledDrawerTitle className={className || ''}>
      {icon && <div>{icon}</div>}
      <h3>{title}</h3>
    </StyledDrawerTitle>
  );
};

export const Title = withTheme(TitleComponent);
